import { withInstall } from '../utils/index';
import Input from './index.vue';
import './index.less';

export const TlbsInput = withInstall(Input);
export default TlbsInput;
